// const devUrl = "http://localhost:8002/";
const devUrl = "https://fk.jd-sf.com";//正式/
// const devUrl = "http://lds.jd-sf.com";//体验
export default {
  tokenKey: 'Authorization',//存在sessionStorage里面的tokenKeyhttp://at.alicdn.com/t/font_1047431_pbh36d6nwfl.css
  apiUrl: devUrl,
  apiPrefix: "api",
  vant: true,
  siteName: '',
  productionGzip: true,
  vueTagData: {},
  productionGzipExtensions: ['js', 'css'],
}




// WEBPACK FOOTER //
// ./src/config/vueConfig.js